import { union, literal } from 'zod'
import type { z } from 'zod'

export function hostSchema() {
  return union([
    literal('dev'),
    literal('ps'),
    literal('ai'),
    literal('xd'),
    literal('id'),
    literal('ae'),
    literal('sk'),
    literal('fi'),
    literal('web'),

    // TODO: Remove this
    literal('adobe'),
  ])
}

export type Host = z.infer<ReturnType<typeof hostSchema>>

export function prettyHost(slug: Host) {
  const dict: { [key in Host]: string } = {
    dev: 'Development',
    ps: 'Photoshop',
    ai: 'Illustrator',
    xd: 'XD',
    id: 'InDesign',
    ae: 'After Effects',
    sk: 'Sketch',
    fi: 'Figma',
    web: 'Web',
    adobe: 'Adobe',
  }
  const name = dict[slug]

  if (!name) {
    throw new Error(`${slug} is not a valid host`)
  }

  return name
}
